import React, { useState } from "react";
import InputItem from "../atoms/InputItem";
import SearchResult from "../molecules/SearchResult";
import Modal from "./Modal";
import styled from "styled-components";
import Http, * as Endpoint from "../../Http";
const SearchResults = styled.div `
    margin: 35px -35px -35px -35px;
    max-height: 476px;
    overflow-y: scroll;
`;
const STATE = {
    INITIAL: "initial",
    SEARCHING: "searching",
    SEARCHING_FINISHED: "searching_finished",
    FETCH_ADDRESS: "fetch_address",
    SEARCHING_ERROR: "search_error",
    FETCH_ADDRESS_ERROR: "search_error",
};
const ChamberOfCommerceSearchModal = ({ showModal, onClose: handleClose, onSelect: handleSelect, }) => {
    const [searchCompanyValue, setSearchCompanyValue] = useState("");
    const [searchMessage, setSearchMessage] = useState("");
    const [state, setState] = useState(STATE.INITIAL);
    const [kvkData, setKvkData] = useState([]);
    const getCompanyData = () => {
        if (!searchCompanyValue) {
            return;
        }
        setState(STATE.SEARCHING);
        setSearchMessage("");
        Http.get(Endpoint.endpoint(Endpoint.COMPANY_SEARCH, {
            query: searchCompanyValue,
        }))
            .then((result) => {
            setState(STATE.SEARCHING_ERROR);
            if (!result.data.total) {
                setState(STATE.SEARCHING_ERROR);
                setSearchMessage("Er zijn geen resultaten gevonden.");
            }
            else {
                setState(STATE.SEARCHING_FINISHED);
            }
            setKvkData(result.data.items);
        })
            .catch(() => {
            setState(STATE.SEARCHING_ERROR);
            setSearchMessage("Er is iets fout gegaan. Probeer het later nog eens.");
        });
    };
    const updateLocationData = (locationOrKvkNumber) => {
        setState(STATE.FETCH_ADDRESS);
        Http.get(Endpoint.endpoint(Endpoint.COMPANY_LOCATION, {
            number: locationOrKvkNumber,
        }))
            .then((result) => {
            handleSelect(result.data);
            setState(STATE.INITIAL);
            handleClose();
        })
            .catch(() => {
            setState(STATE.FETCH_ADDRESS_ERROR);
            setSearchMessage("Er is iets fout gegaan. Probeer het later nog eens.");
        });
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        getCompanyData();
    };
    return (React.createElement(Modal, { showModal: showModal, onClose: handleClose },
        React.createElement("form", { onSubmit: handleSubmit },
            React.createElement(InputItem, { name: "searchCompanyValue", type: "text", label: "Zoek op KVK-nummer of handelsnaam", disabled: state === STATE.SEARCHING ||
                    state === STATE.FETCH_ADDRESS, hasSearchButton: true, loading: state === STATE.SEARCHING ||
                    state === STATE.FETCH_ADDRESS, onChange: (e) => {
                    setSearchCompanyValue(e.currentTarget.value);
                } })),
        state !== STATE.SEARCHING && state !== STATE.SEARCHING_ERROR && (React.createElement(SearchResults, null, kvkData.map((item, index) => (React.createElement(SearchResult, { key: index, onClick: (e) => {
                if (state !== STATE.FETCH_ADDRESS) {
                    updateLocationData(item.location_number || item.kvk_number);
                }
            }, title: item.name, isMain: item.is_main, chamberOfCommerceNumber: item.kvk_number, address: `${item.street || ""} ${item.city || ""}`, disabled: state === STATE.FETCH_ADDRESS }))))),
        searchMessage.length > 0 && React.createElement("p", null, searchMessage)));
};
export default ChamberOfCommerceSearchModal;
